export default __webpack_public_path__ + "static/media/CJCP.f274908a.jpg";